import React from 'react';
import { motion, useReducedMotion } from 'motion/react';

export function SuperheroCharacterOverlay() {
  const shouldReduceMotion = useReducedMotion();

  return (
    <div className="absolute inset-0 pointer-events-none z-20 overflow-hidden">
      {/* Clean, subtle status badge at the top left without blocking content or requiring clicks */}
      <motion.div
        animate={
          shouldReduceMotion
            ? {}
            : {
                y: [0, -6, 0],
              }
        }
        transition={{ duration: 4.5, repeat: Infinity, ease: 'easeInOut' }}
        className="absolute top-16 left-8 md:left-16 pointer-events-auto"
      >
        <div className="flex items-center gap-3 rounded-full border border-sky-400/30 bg-slate-950/70 px-4 py-2 text-xs font-bold tracking-wider text-sky-200 backdrop-blur-md shadow-lg shadow-sky-500/10">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-sky-500"></span>
          </span>
          STARK CYBERNETICS PARTY MISSION
        </div>
      </motion.div>
    </div>
  );
}
